import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { from } from 'rxjs';

@Injectable()
export class ThemeService {
    constructor(
        @Inject(DOCUMENT) private document: Document,
        private http: HttpClient,
    ) {}

    loadStyle(styleName: string, errFallback: () => void = null) {
        const hash = Date.now();
        const head = this.document.getElementsByTagName('head')[0];
        const url = `${styleName}?${hash}`;

        if (head) {
            const fetchPromise = fetch(url, {
                method: 'GET',
            });
            from(fetchPromise).subscribe(
                async (res: Response) => {
                    if (res.status === 200 && !res.redirected) {
                        try {
                            const cssContent = await res.text();
                            let styleTag = this.document.getElementById(
                                'client-theme',
                            ) as HTMLStyleElement;

                            if (!styleTag) {
                                styleTag = this.document.createElement(
                                    'style',
                                ) as HTMLStyleElement;
                                styleTag.id = 'client-theme';
                                head.appendChild(styleTag);
                            }

                            styleTag.innerHTML = cssContent;
                        } catch (error) {
                            if (errFallback) {
                                errFallback();
                            }
                        }
                    }
                },
                (err: any) => {
                    if (errFallback) {
                        errFallback();
                    }
                },
            );
        }
    }
}
